module.exports = __webpack_public_path__ + "img/diamante-verde.62dedc46.png";